import ErrorWithCode from './ErrorWithCode';

export default function isErrorWithCode(value: any): value is ErrorWithCode {
  return value instanceof ErrorWithCode;
}
